@if(!errorMessage) {
@if(this.displayWaitMessage && this.loading){
<p id="vslidatingMessageLabel">
    {{(pageContent | contentFilter: LABELS.AUTH_VALIDATING_MESSAGE) ||'Please Wait! Validating your login...'}}</p>
}
}
@else {
<p class="error-message">{{this.errorMessage}}</p>
}